var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory162(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 293,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-357 -357)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.26 513.462 394.253 369.472C389.537 361.948 380.086 358.96 371.967 362.452 363.813 365.908 359.384 374.799 361.545 383.367L397.547 527.357C399.546 535.384 406.728 541 414.991 541L468.995 541C475.529 541 481.56 537.454 484.746 531.713 487.914 526.007 487.734 519.006 484.26 513.462Z",
    fill: "#F5F8FA",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.521 544.557 577.846 541.333C577.846 511.341 553.551 487 523.615 487 505.05 487 488.691 496.382 478.911 510.635 470.415 507.103 461.087 505.111 451.308 505.111 411.376 505.111 379 537.548 379 577.556 379 617.563 411.376 650 451.308 650 475.983 650 497.729 637.558 510.781 618.65 519.458 637.123 538.041 650 559.769 650 589.723 650 614 625.677 614 595.667 614 571.905 598.707 551.947 577.521 544.557Z",
    fill: "#E1E8ED",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory162);
export default __webpack_public_path__ + "static/media/accessory16-2.294a2ed1fb47123f6b931fadc317738c.svg";
export { ForwardRef as ReactComponent };